import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    user: {},
  },
  getters: {
    collectionNum: state => {
      return state.collectionNum
    },
    userInfo: state => {
      return state.userInfo
    }
  },
  mutations: {

  },
  actions: {

  },
  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js